<template>
  <com-page>
    <com-search :columns="searchColumns" @search="handleSearch"></com-search>
    <com-card>
      <com-table :columns="tableColumns" :api="api" ref="table">
        <template #userId="{ data }">
          {{ data.user.number }}
        </template>
        <template #userPhone="{ data }">
          {{ data.user.phone }}
        </template>
        <template #payType="{ data }">
          {{ data.mode === 'WALLET' ? '钱包支付' : '月卡支付' }}
        </template>
        <template #operation="{ data }">
          <el-button type="primary" size="mini" @click="handleDel(data)">解绑</el-button>
          <el-button type="primary" size="mini" @click="orderRecords(data)">订单记录</el-button>
        </template>
      </com-table>
    </com-card>
    <Records ref="recordsRef" />
  </com-page>
</template>

<script>
import { list as listApi, delCard } from '@/api/electric_card'
import Records from './components/the-records'

export default {
  components: { Records },
  data() {
    return {
      api: listApi,
      searchColumns: [
        {
          label: '电卡号',
          prop: 'cardNo',
          type: 'input',
          placeholder: '请输入电卡号'
        },
        {
          label: '用户id/手机号',
          prop: 'userCondition',
          type: 'input',
          placeholder: '请输入用户id/手机号'
        }
      ],
      tableColumns: [
        {
          label: '电卡号',
          prop: 'cardNo'
        },
        {
          label: '绑定用户ID',
          prop: 'id',
          type: 'slot',
          slotName: 'userId'
        },
        {
          label: '绑定用户手机号',
          prop: 'phone',
          type: 'slot',
          slotName: 'userPhone'
        },
        {
          label: '支付方式',
          prop: 'pay',
          type: 'slot',
          slotName: 'payType'
        },
        {
          label: '操作',
          prop: 'operation',
          type: 'slot',
          slotName: 'operation',
          fixed: 'right'
        }
      ]
    }
  },
  methods: {
    init() {
      this.$refs.table.init()
    },
    orderRecords(row) {
      const params = {
        cardNo: row.cardNo
      }
      this.$refs.recordsRef.open(params)
    },
    handleDel(row) {
      this.$confirm('是否确认解绑该电卡？该操作不可逆', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const params = {
            cardNo: row.cardNo,
            mode: row.mode,
            code: row.code
          }
          delCard(params).then((res) => {
            const { desc } = res
            this.$message.success(desc)
            this.init()
          })
        })
        .catch(() => {})
    },
    handleSearch(row) {
      this.$refs.table.search(row)
    }
  }
}
</script>

<style lang="scss" scoped></style>
